var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardsidenavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 3.49988H18.9999C19.8283 3.49988 20.4999 4.17145 20.4999 4.99988V18.9999C20.4999 19.8283 19.8283 20.4999 18.9999 20.4999H17.9999C17.1715 20.4999 16.4999 19.8283 16.4999 18.9999V4.99988C16.4999 4.17145 17.1715 3.49988 17.9999 3.49988Z",
    stroke: "#24A4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 9.49988H12.4999C13.3283 9.49988 13.9999 10.1715 13.9999 10.9999V18.9999C13.9999 19.8283 13.3283 20.4999 12.4999 20.4999H11.4999C10.6715 20.4999 9.99988 19.8283 9.99988 18.9999V10.9999C9.99988 10.1715 10.6715 9.49988 11.4999 9.49988Z",
    stroke: "#24A4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99988 16.4999H5.99988C6.8283 16.4999 7.49988 17.1715 7.49988 17.9999V18.9999C7.49988 19.8283 6.8283 20.4999 5.99988 20.4999H4.99988C4.17145 20.4999 3.49988 19.8283 3.49988 18.9999V17.9999C3.49988 17.1715 4.17145 16.4999 4.99988 16.4999Z",
    stroke: "#24A4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardsidenavicon);
export default __webpack_public_path__ + "static/media/Dashboardsidenavicon.bdbc74bae3d26b511bec8d0ac57f3bf3.svg";
export { ForwardRef as ReactComponent };